(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-tabs-carousel"] && !Shopify.designMode) return;
  try {
    class CollectionTabsCarouselComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.tabs = this.querySelectorAll('.collection-tabs-carousel__tab');
      this.panels = this.querySelectorAll('.collection-tabs-carousel__panel');
      this.carousels = this.querySelectorAll('[data-carousel]');
      
      this.setupTabs();
      this.setupCarousels();
    }

    setupTabs() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          this.switchTab(index);
        });
      });
    }

    setupCarousels() {
      this.carousels.forEach(carousel => {
        const wrapper = carousel.closest('.collection-tabs-carousel__carousel-wrapper');
        const leftArrow = wrapper?.querySelector('.carousel-arrow--left');
        const rightArrow = wrapper?.querySelector('.carousel-arrow--right');

        if (leftArrow) {
          leftArrow.addEventListener('click', () => {
            this.scrollCarousel(carousel, -1);
          });
        }

        if (rightArrow) {
          rightArrow.addEventListener('click', () => {
            this.scrollCarousel(carousel, 1);
          });
        }

        // Update arrow states on scroll
        carousel.addEventListener('scroll', () => {
          this.updateArrowStates(carousel, leftArrow, rightArrow);
        });

        // Initial arrow state
        setTimeout(() => {
          this.updateArrowStates(carousel, leftArrow, rightArrow);
        }, 100);
      });
    }

    switchTab(activeIndex) {
      this.tabs.forEach((tab, index) => {
        const isActive = index === activeIndex;
        tab.classList.toggle('collection-tabs-carousel__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive);
      });

      this.panels.forEach((panel, index) => {
        const isActive = index === activeIndex;
        panel.classList.toggle('collection-tabs-carousel__panel--active', isActive);
      });
    }

    scrollCarousel(carousel, direction) {
      const product = carousel.querySelector('.collection-tabs-carousel__product');
      if (!product) return;

      const productWidth = product.offsetWidth;
      const gap = 16; // 1rem gap
      const scrollAmount = productWidth + gap;
      
      carousel.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth'
      });
    }

    updateArrowStates(carousel, leftArrow, rightArrow) {
      if (!carousel) return;

      const isAtStart = carousel.scrollLeft <= 16; // Account for padding
      const isAtEnd = carousel.scrollLeft >= carousel.scrollWidth - carousel.offsetWidth - 16;

      if (leftArrow) {
        leftArrow.disabled = isAtStart;
        leftArrow.style.opacity = isAtStart ? '0.3' : '';
      }

      if (rightArrow) {
        rightArrow.disabled = isAtEnd;
        rightArrow.style.opacity = isAtEnd ? '0.3' : '';
      }
    }
  }

  customElements.define('collection-tabs-carousel-component', CollectionTabsCarouselComponent);
  
  // Debug: Add click listeners to collection tabs carousel buttons
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Collection tabs carousel debug: DOM loaded');
    
    // Listen for cart add events
    document.addEventListener('cart:update', function(e) {
      console.log('Collection tabs carousel debug: CartAddEvent fired!', e.detail);
      console.log('Collection tabs carousel debug: Event source:', e.detail.data?.source);
      console.log('Collection tabs carousel debug: Item count:', e.detail.data?.itemCount);
      console.log('Collection tabs carousel debug: Coming from product form?', e.detail.data?.source === 'product-form-component');
    });
    
    const buttons = document.querySelectorAll('.collection-tabs-carousel__add-to-cart-btn');
    console.log('Collection tabs carousel debug: Found buttons:', buttons.length);
    
    buttons.forEach((button, index) => {
      console.log(`Collection tabs carousel debug: Setting up button ${index}`, button);
      
      button.addEventListener('click', function(e) {
        console.log('Collection tabs carousel debug: Button clicked!', e.target);
        console.log('Collection tabs carousel debug: Button disabled?', button.disabled);
        console.log('Collection tabs carousel debug: Product form component:', button.closest('product-form-component'));
        console.log('Collection tabs carousel debug: Add to cart component:', button.closest('add-to-cart-component'));
        
        // Check if form submission is being prevented
        const form = button.closest('product-form-component');
        const variantInput = form?.querySelector('input[name="id"]');
        console.log('Collection tabs carousel debug: Variant ID:', variantInput?.value);
        console.log('Collection tabs carousel debug: Form action should be AJAX, not page redirect');
        
        // Check if the components are properly connected
        const addToCartComponent = button.closest('add-to-cart-component');
        const productFormComponent = button.closest('product-form-component');
        
        console.log('Collection tabs carousel debug: AddToCartComponent methods:', Object.getOwnPropertyNames(addToCartComponent.__proto__));
        console.log('Collection tabs carousel debug: ProductFormComponent methods:', Object.getOwnPropertyNames(productFormComponent.__proto__));
        
        // Prevent default form submission
        e.preventDefault();
        console.log('Collection tabs carousel debug: Form submission prevented');
        
        // Manual AJAX cart add to bypass all form submit issues
        const variantId = variantInput?.value;
        if (variantId) {
          console.log('Collection tabs carousel debug: Making direct AJAX request to add to cart...');
          
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          })
          .then(response => response.json())
          .then(data => {
            console.log('Collection tabs carousel debug: Cart add successful:', data);
            
            // Trigger cart update event manually
            const cartUpdateEvent = new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: data,
                sourceId: 'collection-tabs-carousel',
                data: {
                  source: 'product-form-component',
                  itemCount: 1,
                  variantId: variantId
                }
              }
            });
            document.dispatchEvent(cartUpdateEvent);
            
            // Trigger add to cart animation
            if (addToCartComponent && typeof addToCartComponent.animateAddToCart === 'function') {
              addToCartComponent.animateAddToCart();
            }
          })
          .catch(error => {
            console.error('Collection tabs carousel debug: Cart add failed:', error);
          });
        } else {
          console.log('Collection tabs carousel debug: No variant ID found');
        }
        
        // Listen for cart events
        setTimeout(() => {
          console.log('Collection tabs carousel debug: Checking if CartAddEvent was fired...');
        }, 1000);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-tabs"] && !Shopify.designMode) return;
  try {
    class CollectionTabsComponent extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('.collection-tabs__tab');
      this.panels = this.querySelectorAll('.collection-tabs__panel');
      this.init();
      this.setupPagination();
    }

    init() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.switchTab(index));
      });
    }

    setupPagination() {
      // Add arrow events and initial pagination state per panel
      this.panels.forEach(panel => {
        const productsContainer = panel.querySelector('.collection-tabs__products');
        const products = Array.from(panel.querySelectorAll('.collection-tabs__product'));
        const leftArrow = panel.querySelector('.collection-tabs__arrow--left');
        const rightArrow = panel.querySelector('.collection-tabs__arrow--right');

        // Compute columns from computed grid-template-columns of the container
        const getColumns = () => {
          const styles = window.getComputedStyle(productsContainer);
          let template = styles.gridTemplateColumns || styles.getPropertyValue('grid-template-columns');
          if (!template) return 4;
          template = String(template).trim();
          if (template === 'none') return 4;
          const count = template.split(/\s+/).filter(Boolean).length;
          return Math.max(1, count || 4);
        };

        const state = { page: 0 };

        const update = () => {
          const cols = getColumns();
          const perPage = cols; // grid shows one row, so per page equals columns
          const total = products.length;
          const pages = Math.max(1, Math.ceil(total / perPage));
          state.page = Math.min(state.page, pages - 1);
          const start = state.page * perPage;
          const end = start + perPage;

          products.forEach((item, idx) => {
            const visible = idx >= start && idx < end;
            item.style.display = visible ? 'flex' : 'none';
          });

          if (leftArrow) leftArrow.disabled = state.page <= 0;
          if (rightArrow) rightArrow.disabled = state.page >= pages - 1;
        };

        leftArrow?.addEventListener('click', () => {
          state.page = Math.max(0, state.page - 1);
          update();
        });
        rightArrow?.addEventListener('click', () => {
          const cols = getColumns();
          const total = products.length;
          const pages = Math.max(1, Math.ceil(total / cols));
          state.page = Math.min(pages - 1, state.page + 1);
          update();
        });

        // Ensure arrow disabled state reflects page boundaries also on init
        if (leftArrow) leftArrow.addEventListener('mousedown', e => e.preventDefault());
        if (rightArrow) rightArrow.addEventListener('mousedown', e => e.preventDefault());

        // Update on resize to recalc columns
        const ro = new ResizeObserver(() => {
          // Reset page index to 0 if current page exceeds max after resize
          const cols = getColumns();
          const total = products.length;
          const pages = Math.max(1, Math.ceil(total / cols));
          if (state.page > pages - 1) state.page = pages - 1;
          update();
        });
        ro.observe(productsContainer);

        // Initial render — ensure we start from page 0 consistently
        state.page = 0;
        update();

        // Save state on panel for later if needed
        panel._pagination = { state, update };
      });
    }

    switchTab(activeIndex) {
      // Update tabs
      this.tabs.forEach((tab, index) => {
        const isActive = index === activeIndex;
        tab.classList.toggle('collection-tabs__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive);
      });

      // Update panels
      this.panels.forEach((panel, index) => {
        const isActive = index === activeIndex;
        panel.classList.toggle('collection-tabs__panel--active', isActive);
      });

      // Recalculate pagination for the newly active panel (ensure correct columns)
      const activePanel = this.panels[activeIndex];
      if (activePanel && activePanel._pagination) {
        activePanel._pagination.state.page = 0;
        requestAnimationFrame(() => activePanel._pagination.update());
      }
    }
  }

  customElements.define('collection-tabs-component', CollectionTabsComponent);
  
  // Debug: Add click listeners to collection tabs buttons
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Collection tabs debug: DOM loaded');
    
    // Listen for cart add events
    document.addEventListener('cart:update', function(e) {
      console.log('Collection tabs debug: CartAddEvent fired!', e.detail);
      console.log('Collection tabs debug: Event source:', e.detail.data?.source);
      console.log('Collection tabs debug: Item count:', e.detail.data?.itemCount);
      console.log('Collection tabs debug: Coming from product form?', e.detail.data?.source === 'product-form-component');
    });
    
    const buttons = document.querySelectorAll('.collection-tabs__add-to-cart-btn');
    console.log('Collection tabs debug: Found buttons:', buttons.length);
    
    buttons.forEach((button, index) => {
      console.log(`Collection tabs debug: Setting up button ${index}`, button);
      
      button.addEventListener('click', function(e) {
        console.log('Collection tabs debug: Button clicked!', e.target);
        console.log('Collection tabs debug: Button disabled?', button.disabled);
        console.log('Collection tabs debug: Product form component:', button.closest('product-form-component'));
        console.log('Collection tabs debug: Add to cart component:', button.closest('add-to-cart-component'));
        
        // Check if form submission is being prevented
        const form = button.closest('product-form-component');
        const variantInput = form?.querySelector('input[name="id"]');
        console.log('Collection tabs debug: Variant ID:', variantInput?.value);
        console.log('Collection tabs debug: Form action should be AJAX, not page redirect');
        
        // Check if the components are properly connected
        const addToCartComponent = button.closest('add-to-cart-component');
        const productFormComponent = button.closest('product-form-component');
        
        console.log('Collection tabs debug: AddToCartComponent methods:', Object.getOwnPropertyNames(addToCartComponent.__proto__));
        console.log('Collection tabs debug: ProductFormComponent methods:', Object.getOwnPropertyNames(productFormComponent.__proto__));
        
        // Prevent default form submission
        e.preventDefault();
        console.log('Collection tabs debug: Form submission prevented');
        
        // Manual AJAX cart add to bypass all form submit issues
        const variantId = variantInput?.value;
        if (variantId) {
          console.log('Collection tabs debug: Making direct AJAX request to add to cart...');
          
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          })
          .then(response => response.json())
          .then(data => {
            console.log('Collection tabs debug: Cart add successful:', data);
            
            // Trigger cart update event manually
            const cartUpdateEvent = new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: data,
                sourceId: 'collection-tabs',
                data: {
                  source: 'product-form-component',
                  itemCount: 1,
                  variantId: variantId
                }
              }
            });
            document.dispatchEvent(cartUpdateEvent);
            
            // Trigger add to cart animation
            if (addToCartComponent && typeof addToCartComponent.animateAddToCart === 'function') {
              addToCartComponent.animateAddToCart();
            }
          })
          .catch(error => {
            console.error('Collection tabs debug: Cart add failed:', error);
          });
        } else {
          console.log('Collection tabs debug: No variant ID found');
        }
        
        // Listen for cart events
        setTimeout(() => {
          console.log('Collection tabs debug: Checking if CartAddEvent was fired...');
        }, 1000);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
